import React from 'react'
import PropTypes from 'prop-types'
import {  graphql } from 'gatsby'


import Layout from '../components/Layout'

import Hero from '../components/Hero'
import Skills from './../components/Skills/Skills';
import Services from '../components/Services/Services';

import 'bulma/css/bulma.css';

import About from '../components/About/About';

export const IndexPageTemplate = ({
  image,
  title,
  heading,
  subheading,
  mainpitch,
  description,
  intro,
}) => (
  <div>
  <Hero/>
  
            <div style={{alignContent:'center',justifyContent:'center',padding:80}}>
                <Skills/>
               <Services/>
            </div>
  </div>
)

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const IndexPage = (props) => {
 
  const {data}=props;
  const { frontmatter } = data.markdownRemark
  

  return (
    <Layout>
  
  <div id="home" style={{alignContent:'center'}}><Hero/></div>
     <section className="section"  >
         
            <div id="about"><About/></div>
            <div id="skills"><Skills/></div>
            <div id="services"><Services/></div>
           
            </section>
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        heading
        subheading
        mainpitch {
          title
          description
        }
        description
        intro {
          blurbs {
            image {
              childImageSharp {
                fluid(maxWidth: 240, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            text
          }
          heading
          description
        }
      }
    }
  }
`
